import { SVGProps } from 'react';

const ChevronsLeftRightEllipsis = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 12h.01M16 12h.01M17 7l5 5-5 5M7 7l-5 5 5 5m1-5h.01"
    />
  </svg>
);
export default ChevronsLeftRightEllipsis;
